function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "pipe_svg__a",
  d: "M0 .41h41.987V56H0z"
}), React.createElement("path", {
  id: "pipe_svg__c",
  d: "M.023.625H24v65.393H.023z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#231F20",
  d: "M1.94 140.18S105.61 24.047 291.495.062c1.125 18.739 3.462 37.53 5.335 65.264C183.275 83.314 79.544 145.018 39.978 193.023 21.99 169.037 1.94 140.18 1.94 140.18"
}), React.createElement("g", {
  transform: "translate(0 138.375)"
}, React.createElement("mask", {
  id: "pipe_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#pipe_svg__a"
})), React.createElement("path", {
  fill: "#BBBDBF",
  d: "M30.656 21.531c10.29 14.897 14.307 29.963 8.97 33.65-5.335 3.685-18.003-5.404-28.294-20.302S-2.976 4.916 2.36 1.23c5.337-3.686 18.005 5.403 28.296 20.301",
  mask: "url(#pipe_svg__b)"
})), React.createElement("g", {
  transform: "translate(282 -.625)"
}, React.createElement("mask", {
  id: "pipe_svg__d",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#pipe_svg__c"
})), React.createElement("path", {
  fill: "#BBBDBF",
  d: "M23.718 32.4c1.421 18.051-2.669 33.096-9.135 33.605C8.118 66.514 1.725 52.294.305 34.243-1.115 16.192 2.973 1.147 9.44.638 15.904.129 22.297 14.349 23.72 32.4",
  mask: "url(#pipe_svg__d)"
})));

var SvgPipe = function SvgPipe(props) {
  return React.createElement("svg", _extends({
    width: 306,
    height: 195
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzA2IiBoZWlnaHQ9IjE5NSIgdmlld0JveD0iMCAwIDMwNiAxOTUiPgogIDxkZWZzPgogICAgPHBvbHlnb24gaWQ9InBpcGUtYSIgcG9pbnRzPSIwIC40MSA0MS45ODcgLjQxIDQxLjk4NyA1NiAwIDU2Ii8+CiAgICA8cG9seWdvbiBpZD0icGlwZS1jIiBwb2ludHM9Ii4wMjMgLjYyNSAyNCAuNjI1IDI0IDY2LjAxOCAuMDIzIDY2LjAxOCIvPgogIDwvZGVmcz4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTEpIj4KICAgIDxwYXRoIGZpbGw9IiMyMzFGMjAiIGQ9Ik0xLjkzOTEsMTQxLjE3OTggQzEuOTM5MSwxNDEuMTc5OCAxMDUuNjEwMSwyNS4wNDY4IDI5MS40OTYxLDEuMDYxOCBDMjkyLjYyMTEsMTkuODAwOCAyOTQuOTU4MSwzOC41OTE4IDI5Ni44MzExLDY2LjMyNTggQzE4My4yNzUxLDg0LjMxMzggNzkuNTQ0MSwxNDYuMDE3OCAzOS45NzgxLDE5NC4wMjI4IEMyMS45ODkxLDE3MC4wMzY4IDEuOTM5MSwxNDEuMTc5OCAxLjkzOTEsMTQxLjE3OTgiLz4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMTM5LjM3NSkiPgogICAgICA8bWFzayBpZD0icGlwZS1iIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNwaXBlLWEiLz4KICAgICAgPC9tYXNrPgogICAgICA8cGF0aCBmaWxsPSIjQkJCREJGIiBkPSJNMzAuNjU1OSwyMS41MzEzIEM0MC45NDU5LDM2LjQyODMgNDQuOTYyOSw1MS40OTQzIDM5LjYyNjksNTUuMTgwMyBDMzQuMjkwOSw1OC44NjYzIDIxLjYyMjksNDkuNzc3MyAxMS4zMzE5LDM0Ljg3OTMgQzEuMDQwOSwxOS45ODEzIC0yLjk3NjEsNC45MTYzIDIuMzU5OSwxLjIzMDMgQzcuNjk2OSwtMi40NTU3IDIwLjM2NDksNi42MzMzIDMwLjY1NTksMjEuNTMxMyIgbWFzaz0idXJsKCNwaXBlLWIpIi8+CiAgICA8L2c+CiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyODIgLjM3NSkiPgogICAgICA8bWFzayBpZD0icGlwZS1kIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNwaXBlLWMiLz4KICAgICAgPC9tYXNrPgogICAgICA8cGF0aCBmaWxsPSIjQkJCREJGIiBkPSJNMjMuNzE4NCwzMi40IEMyNS4xMzk0LDUwLjQ1MSAyMS4wNDk0LDY1LjQ5NiAxNC41ODM0LDY2LjAwNSBDOC4xMTg0LDY2LjUxNCAxLjcyNTQsNTIuMjk0IDAuMzA1NCwzNC4yNDMgQy0xLjExNTYsMTYuMTkyIDIuOTczNCwxLjE0NyA5LjQzOTQsMC42MzggQzE1LjkwNDQsMC4xMjkgMjIuMjk3NCwxNC4zNDkgMjMuNzE4NCwzMi40IiBtYXNrPSJ1cmwoI3BpcGUtZCkiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgPipe as ReactComponent };